import React from 'react';
import {withRouter} from 'react-router-dom';
import Paragraph from '../../components/Paragraph';
import View from '../../components/View';
import './styles.scss';

const Index = (props) => {
  const isRecommend = /recommend/.test(props.location.pathname);
  return (
    <View title="Спасибо!" className="view--thank-you">
      {
        isRecommend
          ? (
            <Paragraph>
              Специальная ссылка на вакансию отправлена.<br />
              С вами свяжутся, в случае успешного прохождения кандидатом испытательного срока.
            </Paragraph>
          ) : (
            <Paragraph>
              Мы свяжемся с вами в течение 5 рабочих дней в случае заинтересованности.
            </Paragraph>
          )
      }
    </View>
  );
};

export default withRouter(Index);
